import { useTheme } from "@/providers/ThemeProvider";

const useAppThemeColor = () => {
  const { resolvedTheme } = useTheme();

  const backgroundColor = resolvedTheme === "dark" ? "black" : "white";
  const headerTintColor = resolvedTheme === "dark" ? "white" : "black";
  const borderColor = resolvedTheme === "dark" ? "#525252" : "#e5e5e5";

  return {
    backgroundColor,
    headerTintColor,
    borderColor,
    isDark: resolvedTheme === "dark",
  };
};

export default useAppThemeColor;
